import { IVisitingDay } from '@interfaces'
import visitTR from '@/locales/tr/visit.json'
import visitEN from '@/locales/en/visit.json'
import commonTR from '@/locales/tr/common.json'
import commonEN from '@/locales/en/common.json'
import { v4 as uuidv4 } from 'uuid'

type WeekdayKey =
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday'
  | 'sunday'

// Monday (0) through Sunday (6) — matches getOpeningHourLabelCurrentMuseum index order
const MUSEUM_WEEKLY_SCHEDULE: { dayKey: WeekdayKey; isClosed: boolean }[] = [
  { dayKey: 'monday', isClosed: true },
  { dayKey: 'tuesday', isClosed: false },
  { dayKey: 'wednesday', isClosed: false },
  { dayKey: 'thursday', isClosed: false },
  { dayKey: 'friday', isClosed: false },
  { dayKey: 'saturday', isClosed: false },
  { dayKey: 'sunday', isClosed: false },
]

// JS getDay(): 0=Sunday … 6=Saturday → schedule index (Monday=0 … Sunday=6)
const JS_DAY_TO_SCHEDULE_INDEX = [6, 0, 1, 2, 3, 4, 5]

export const getMuseumOpeningHours = (locale: string): IVisitingDay[] => {
  const visit = locale === 'tr' ? visitTR : visitEN
  const openingHoursLabel =
    locale === 'tr'
      ? commonTR.museumProgram.weekdayOpeningHours
      : commonEN.museumProgram.weekdayOpeningHours

  const todayScheduleIndex = JS_DAY_TO_SCHEDULE_INDEX[new Date().getDay()]

  return MUSEUM_WEEKLY_SCHEDULE.map((schedule, index) => ({
    id: uuidv4(),
    dayType: schedule.isClosed
      ? 'alwaysClosed'
      : index === todayScheduleIndex
      ? 'isActive'
      : 'isNotActive',
    dayName: visit.informationAndTransportation.visitingDays[schedule.dayKey],
    isClosed: schedule.isClosed,
    openingHours: schedule.isClosed ? undefined : openingHoursLabel,
  }))
}
